import { render, staticRenderFns } from "./chatLog.vue?vue&type=template&id=7dc48c84&scoped=true"
import script from "./chatLog.vue?vue&type=script&lang=js"
export * from "./chatLog.vue?vue&type=script&lang=js"
import style0 from "./chatLog.vue?vue&type=style&index=0&id=7dc48c84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc48c84",
  null
  
)

export default component.exports